/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Assets
import { PlusWhiteIcon } from 'assets/images/Icons'

// Store
import { actions } from 'core/store'

// Hooks
import { useFetchAllTransfers } from 'core/hooks/api'

// Styled Elements
import { TravelRuleTableWrapper, TravelRuleHeaderWrapper, TravelRuleHeaderContainer } from './TravelRuleTable.elements'

// Views
import { Button, AccordionTable, EmptyTablePlaceholder } from 'views/components'

// Layouts
import { TravelRuleTableFilter } from 'views/layouts'

import TravelRuleTableItem from '../TravelRuleTableItem'
import TravelRuleSearchInput from '../TravelRuleSearchInput'
import TravelRuleTableItemLoading from '../TravelRuleTableItemLoading'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function TravelRuleTable(props) {
  // Destructure
  const { actions, filters, ui } = props
  const { travelRuleFilters } = filters
  const { isPageTableUpdated } = ui
  const { setIsTransferDrawerOpen, setTravelRuleFilters, setIsPageTableUpdated, toggleTransferReportModal } = actions

  // Hooks
  const [transfersData, setTransfersData] = useState({ items: [], total: 0 })
  const { getAllTransfers, allTransferData, isAllTransferLoading } = useFetchAllTransfers()

  // State
  const [isTransferLoading, setIsTransferLoading] = useState(false)

  // Functions
  const fetchData = async () => {
    getAllTransfers(travelRuleFilters)
  }
  const handleOnTransferSearch = (data) => {
    if (!data) {
      return getAllTransfers(travelRuleFilters)
    }
    setTransfersData({ items: data, total: 0 })
  }

  // UseEffects
  useEffect(() => {
    setTravelRuleFilters()
  }, [])
  useEffect(() => fetchData(), [travelRuleFilters])
  useEffect(() => allTransferData && setTransfersData(allTransferData), [allTransferData])
  useEffect(() => {
    if (isPageTableUpdated) {
      fetchData()
      setIsPageTableUpdated(false)
    }
  }, [isPageTableUpdated])

  return (
    <TravelRuleTableWrapper>
      <AccordionTable
        minWidth={700}
        totalItems={transfersData.total}
        tableFilters={travelRuleFilters}
        setTableFilters={setTravelRuleFilters}
        filterComponents={
          <TravelRuleSearchInput
            setIsTransferLoading={setIsTransferLoading}
            onTransferSearch={handleOnTransferSearch}
          />
        }
        headerOptions={
          <TravelRuleHeaderWrapper>
            <TravelRuleTableFilter />
            <TravelRuleHeaderContainer>
              <Button
                size="small"
                variant="outlined"
                startIcon={<PlusWhiteIcon size={12} />}
                onClick={() => {
                  toggleTransferReportModal()
                }}
              >
                Report
              </Button>
              <Button
                size="small"
                variant="outlined"
                startIcon={<PlusWhiteIcon size={12} />}
                onClick={() => {
                  setIsTransferDrawerOpen(true)
                }}
              >
                Transfer
              </Button>
            </TravelRuleHeaderContainer>
          </TravelRuleHeaderWrapper>
        }
      >
        {(isAllTransferLoading || isTransferLoading) &&
          Array.from({ length: travelRuleFilters?.size || 10 }).map((_, index) => (
            <TravelRuleTableItemLoading key={index} />
          ))}

        {transfersData.items.length > 0 &&
          !isAllTransferLoading &&
          !isTransferLoading &&
          transfersData.items.map((singleData) => <TravelRuleTableItem key={singleData?.id} data={singleData} />)}

        {transfersData?.items?.length < 1 && !isAllTransferLoading && !isTransferLoading && (
          <EmptyTablePlaceholder setFilter={setTravelRuleFilters} />
        )}
      </AccordionTable>
    </TravelRuleTableWrapper>
  )
}

// Default Props
TravelRuleTable.defaultProps = {
  actions: {},
  ui: {},
  filters: {},
}

// Proptypes Validation
TravelRuleTable.propTypes = {
  actions: PropTypes.shape({
    setAddressChains: PropTypes.func,
    setTravelRuleFilters: PropTypes.func,
    setIsTransferDrawerOpen: PropTypes.func,
    setShowHeaderLoader: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
    toggleTransferReportModal: PropTypes.func,
    toggleUpgradeModal: PropTypes.func,
    setInfoModalDetails: PropTypes.func,
  }),
  ui: PropTypes.shape({
    isPageTableUpdated: PropTypes.bool,
  }),
  filters: PropTypes.shape({
    travelRuleFilters: PropTypes.instanceOf(Object),
  }),
  address: PropTypes.shape({
    addressChains: PropTypes.shape({}),
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(TravelRuleTable)
